import { styled } from '@vebox/etui-system';
import '../utilities/responsive.js';
import { Component, createElement } from 'react';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '@vebox/etui-colors';
import 'date-fns';
import 'date-arithmetic';
import '../dates-492a56eb.js';
import { getTimeSlots } from './utils/getTimeSlots.js';
import { a as GridSlotGroup } from '../GridSlotGroup-ad0bba3c.js';

const GridGutterDiv = styled(Div)`
  border-top: 1px solid ${({
  theme
}) => theme.palette.divider};
  min-width: 40px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

class GridGutter extends Component {
  constructor(props) {
    super(props);
    const {
      min,
      max,
      timeStep
    } = this.props;
    this.timeSlotGetter = getTimeSlots({
      min,
      max,
      timeStep
    });
  }
  componentDidUpdate() {
    const {
      min,
      max,
      timeStep
    } = this.props;
    this.timeSlotGetter = this.timeSlotGetter.update({
      min,
      max,
      timeStep
    });
  }
  render() {
    const {
      timeFormat
    } = this.props;
    return /*#__PURE__*/createElement(GridGutterDiv, null, this.timeSlotGetter.groups.map((group, index) => {
      return /*#__PURE__*/createElement(GridSlotGroup, {
        key: index,
        group: group,
        timeFormat: timeFormat
      });
    }));
  }
}

export default GridGutter;
